import React from "react";
import { useLang } from "@/context/LangContext";
import { HERO } from "@/constants/testIds";
import { ArrowRight } from "lucide-react";

const Hero = () => {
  const { t } = useLang();

  return (
    <section id="top" className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden">
      {/* Background image with overlay */}
      <div className="absolute inset-0 -z-10">
        <img
          src="https://images.unsplash.com/photo-1523292864699-4dcfd824dae2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxjbGFzc2ljJTIwZXVyb3BlYW4lMjBhcmNoaXRlY3R1cmUlMjBtYXJibGV8ZW58MHx8fHwxNzgxMjg3NDE2fDA&ixlib=rb-4.1.0&q=85"
          alt=""
          className="w-full h-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-[#FBF9F6]/85" />
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
        {/* Left side - Typography */}
        <div className="lg:col-span-7">
          <p className="overline fade-up" data-testid="hero-overline">
            {t.hero.overline}
          </p>
          <h1 className="display mt-6 text-[56px] sm:text-[80px] md:text-[110px] lg:text-[128px] text-[#1A0010] fade-up delay-1">
            {t.hero.titleLine1}
            <br />
            <span className="italic font-light text-[#66023C]">
              {t.hero.titleLine2}
            </span>
          </h1>
          <div className="hairline-strong w-32 my-9 fade-up delay-2" />
          <p className="serif text-xl md:text-2xl text-[#4D3D46] max-w-[640px] font-light leading-relaxed fade-up delay-2">
            {t.hero.tagline}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 mt-10 fade-up delay-3">
            <a href="#contact" data-testid={HERO.ctaPrimary} className="btn-imperial">
              {t.hero.ctaPrimary} <ArrowRight size={14} strokeWidth={1.5} />
            </a>
            <a href="#about" data-testid={HERO.ctaSecondary} className="btn-ghost">
              {t.hero.ctaSecondary}
            </a>
          </div>
        </div>

        {/* Right side - portrait */}
        <div className="lg:col-span-5 fade-up delay-2 relative">
          <div className="relative">
            <img
              src="https://customer-assets.emergentagent.com/job_cabinet-juridic/artifacts/h5vyp2x6_unnamed%20%281%29.webp"
              alt="Av. Martiș Biatrice-Olimpia"
              className="editorial-img w-full h-[440px] md:h-[560px] object-cover object-top"
            />
            <div className="absolute -bottom-4 -right-4 w-full h-full border border-[#D4AF37] -z-10" />
          </div>

          {/* Mini stats */}
          <div className="grid grid-cols-3 mt-10 border-t border-[#D4AF37]/40">
            {[
              [t.hero.stat1Value, t.hero.stat1Label],
              [t.hero.stat2Value, t.hero.stat2Label],
              [t.hero.stat3Value, t.hero.stat3Label],
            ].map(([v, l], idx) => (
              <div
                key={idx}
                className={`py-5 px-3 ${idx < 2 ? "border-r border-[#D4AF37]/40" : ""}`}
              >
                <div className="serif text-3xl md:text-4xl text-[#66023C]">{v}</div>
                <div className="overline mt-2 !text-[#4D3D46]">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Marquee ribbon */}
      <div className="mt-24 border-y border-[#D4AF37]/30 overflow-hidden py-5 bg-[#F3EFE9]/40">
        <div className="marquee-track">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="flex items-center gap-16 pr-16 shrink-0">
              {[
                "Legea 51/1995",
                "✦",
                "Baroul Galați",
                "✦",
                "Secret profesional",
                "✦",
                "Strategie procesuală",
                "✦",
                "Devotament",
                "✦",
                "Discreție absolută",
                "✦",
              ].map((w, j) => (
                <span
                  key={j}
                  className="serif italic text-2xl md:text-3xl text-[#1A0010]/70 whitespace-nowrap"
                >
                  {w}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
